import Container, { Reducer } from './container'
import Toggles from './toggles'
import FilterButton from './view/filter-button'

export {
  Toggles,
  Reducer,
  FilterButton
}
export default Container


// WEBPACK FOOTER //
// ./src/ui/active-filter/index.js